export default function addDays(date: Date, days: number): Date {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate
}

export function parseLocalDate(value: string): Date {
    const [year, month, day] = value.split('-').map(Number)
    return new Date(year, (month || 1) - 1, day || 1)
}

export function formatLocalDate(value: Date): string {
    const year = value.getFullYear()
    const month = String(value.getMonth() + 1).padStart(2, '0')
    const day = String(value.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

/** The UTC day of a moment, "YYYY-MM-DD": the server's day for daily caps. */
export function formatUTCDate(value: Date): string {
    return value.toISOString().slice(0, 10)
}

export function formatLocalTime(value: Date): string {
    const hours = String(value.getHours()).padStart(2, '0')
    const minutes = String(value.getMinutes()).padStart(2, '0')
    return `${hours}:${minutes}`
}

function getDateStartEnd(timestamp: number): {
    dateStart: Date
    dateEnd: Date
} {
    const date = new Date(timestamp)

    const dateStart = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
    )

    const dateEnd = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
        999
    )

    return { dateStart, dateEnd }
}

export function addDurationToTime(
    timeString: string,
    durationMinutes: number
): string {
    const [hoursStr, minutesStr] = timeString.split(':')
    const totalMinutes =
        parseInt(hoursStr) * 60 + parseInt(minutesStr) + durationMinutes

    const newHours = Math.floor(totalMinutes / 60)
    const newMinutes = Math.round(totalMinutes % 60)

    return `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`
}

export function getNowUTC(): number {
    return Date.now()
}

export const HOUR_MS = 60 * 60 * 1000
export const DAY_MS = 24 * HOUR_MS

/** The device's IANA timezone, or undefined when the runtime hides it. */
export function deviceTimezone(): string | undefined {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined
    } catch {
        return undefined
    }
}
